export const DEACTIVATED_ACCOUNT_STATUS = 'inactive';
export const isUserDeactivated = (accountStatus?: string | null) => accountStatus === DEACTIVATED_ACCOUNT_STATUS;
